// extracted by mini-css-extract-plugin
export default {"toggle":"AppToggle_toggle__48b80"};